// import superagentPromise from 'superagent-promise';
// import _superagent from 'superagent';
import axios from 'axios';
// import axiosCancel from 'axios-cancel';
import Qs from 'qs';
import { getTime } from './common';
import appStore from './stores/appStore';
import _ from 'lodash';
import mocData from './mocData.json';
import { v4 as uuidv4 } from 'uuid';
import ImprintHash from '~/web-frontend-core/utils/getImprintHash';

// const superagent = superagentPromise(_superagent, global.Promise);

// axiosCancel(axios, {
//   debug: false // default
// });
let API_ROOT = '';

let terminalData = {};

if (process.env.NODE_ENV === 'development') {
  API_ROOT = 'https://irm.dev.almara.org';
  // API_ROOT = 'http://pre.almara.org:8084';
  // API_ROOT = 'http://1ng.almara.org:8083'
  // API_ROOT = 'http://1ng.almara.org:8083'
  // API_ROOT = process.env.APP_URL;
  terminalData = {
    session_id: process.env.TERMINAL.sess_id,
    terminal_id: process.env.TERMINAL.terminal_id,
    cashbox_id: process.env.TERMINAL.kass_id,
  }
}

const handleErrors = err => {
  if (err && err.response && err.response.status === 401) {

  }
  return false;
};

const responseBody = res => {
  if (res) {
    if (res.data && res.data.code == 'TERMINAL') {
      appStore.clear('TERMINAL');
    }
    else if (res.data && res.data.code == 'ACCESS') {
      appStore.clear('ACCESS');
    }
    else {
      return res.data
    }
  }
  return false;
};

// const tokenPlugin = req => {
//   if (commonStore.token) {
//     req.set('authorization', `Token ${commonStore.token}`);
//   }
// };

// const requests = {
//   del: url =>
//     superagent
//       .del(`${API_ROOT}${url}`)
//       // .use(tokenPlugin)
//       .end(handleErrors)
//       .then(responseBody),
//   get: url =>
//     superagent
//       .get(`${API_ROOT}${url}`)
//       // .use(tokenPlugin)
//       .end(handleErrors)
//       .then(responseBody),
//   put: (url, body) =>
//     superagent
//       .put(`${API_ROOT}${url}`, body)
//       // .use(tokenPlugin)
//       .end(handleErrors)
//       .then(responseBody),
//   post: (url, body) =>
//     superagent
//       .post(`${API_ROOT}${url}`, body)
//       // .use(tokenPlugin)
//       .end(handleErrors)
//       .then(responseBody),
//   stop: () =>
//     superagent
//       .end()
// };

const axiosClient = axios.create({
  withCredentials: true,
  headers: {
    'X-IRM-Version': 1,
  },
})

axiosClient.interceptors.request.use(async (config) => {
  try {
    const imprint = await ImprintHash.getInstance().imprint();

    config.headers['Imprinthash'] = imprint;
  } catch(e) {
    console.error('Failed to create imprintHash', e)
  }

  return config;
})

const requests = {
  // del: url =>
  //   axios
  //     .del(`${API_ROOT}${url}`)
  //     // .use(tokenPlugin)
  //     .end(handleErrors)
  //     .then(responseBody),
  get: (url, mode) =>
    axiosClient
      .get(`${API_ROOT}${url}`, {
        headers: {
          'X-Request-ID': uuidv4(),
        }
      })
      // .use(tokenPlugin)
      .catch((thrown) => {
        if (axiosClient.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          handleErrors(thrown)
        }
      })
      .then(responseBody),
  // put: (url, body) =>
  //   axios
  //     .put(`${API_ROOT}${url}`, body)
  //     // .use(tokenPlugin)
  //     .end(handleErrors)
  //     .then(responseBody),
  post: (url, body) => {
    return axiosClient
      .post(`${API_ROOT}${url}`, Qs.stringify(body), {
        headers: {
          'X-Request-ID': uuidv4(),
        }
      })
      // .use(tokenPlugin)
      .catch(handleErrors)
      .then(responseBody)
  },
  // cancel: (mode) =>
  //   axios.cancel()
};

const terminal = {
  login: () =>
    requests.get(`/ajax/terminal/login?t`),
  check: (data = terminalData) =>
    requests.get(`/ajax/terminal/check?session_id=${data.session_id}&terminal_id=${data.terminal_id}&cashbox_id=${data.cashbox_id}`),
  getMode: (data) =>
    requests.get(`/ajax/terminal/get_mode?cashbox_id=${data.cashbox_id}`),
  getCurrency: () =>
    requests.get(`/ajax/terminal/get_currency`),
};

const auth = {
  login: (data) =>
    requests.post(`/ajax/login/auth`, data),
  loginCard: (data) =>
    requests.post(`/ajax/login/card`, data),
  logout: (hash) =>
    requests.get(`/ajax/login/logout?h=${hash}`),
};

const data = {
  get: () =>
    requests.get(`/ajax/data/get`)
};

const html = {
  get: (id) =>
    requests.post(`/ajax/html/get`, id)
}

const search = {
  get: (str) =>
    requests.get(`/ajax/searchbox?str=${str}`)
};

const checker = {
  get: () =>
    requests.get(`/terminal`)
};

const finance = {
  getPayout: () =>
    requests.get(`/ajax/finance/payout_data`),
  createPayout: (data) =>
    requests.post(`/ajax/finance/create_payout`, data),
  cancelPayout: (data) =>
    requests.post(`/ajax/finance/cancel_payout`, data),
  checkPayout: () =>
    requests.get(`/ajax/finance/check_payout`)
};

const user = {
  get: () =>
    requests.get(`/ajax/account/get`),
  getBalance: () =>
    requests.get(`/ajax/account/balance`),
  getAccountData: () =>
    requests.get(`/ajax/account/get`),
  getHistoryData: () =>
    requests.get(`/ajax/account/history_data`),
  getHistory: (data) =>
    requests.post(`/ajax/account/history`, data),
  setCancel: (data) =>
    requests.post(`/ajax/payment/cancel`, data),
  getBetsData: () =>
    requests.get(`/ajax/account/bets_data`),
  getBetsPeriodData: () =>
    requests.get(`/ajax/account/bets_data_period`),
  getBets: (data) =>
    requests.post(`/ajax/account/bets_period`, data),
  savePass: (data) =>
    requests.post(`/ajax/account/change_psw`, data),
  setFastAmount: (data) =>
    requests.post(`/ajax/fast_amount/set`, data),
  getCountBets: () =>
    requests.get(`/ajax/account/count_bets`), //deprecated WEB-4944
  sellBet: (wagerId, amount) =>
    requests.get(`/ajax/sell_bet?wager_id=${wagerId}&amount=${amount}`),
};

const slides = {
  getIrmBanners: () =>
    requests.get(`/ajax/promo/get_irm_banners`)
};

const lineMenu = {
  get: ({ cashboxMode = 2 }) =>
    requests.get(`/ajax/line/get_menu${typeof cashboxMode !== 'undefined' ? `?cashbox_mode=${cashboxMode}` : ''}`),
};

const liveMenu = {
  get: ({ cashboxMode = 2 }) => requests.get(`/ajax/live/favlist/${getTime()}${typeof cashboxMode !== 'undefined' ? `?cashbox_mode=${cashboxMode}` : ''}`),
  getFav: () =>
    requests.get(`/ajax/live/getfav`),
  setFav: (data) =>
    requests.post(`/ajax/live/setfav`, data),
  getVideo: () =>
    requests.get(`/ajax/video/get_list`),
};

const lineResults = {
  getFilter: () =>
    requests.get(`/ajax/results/get_data`),
  getResults: (data) =>
    requests.get(`/v1/matchesresults?${Qs.stringify(data)}`),
};

const liveResults = {
  getFilter: () =>
    requests.get(`/ajax/results/get_data_live`),
  getResults: (data) =>
    requests.post(`/ajax/results/get_live?${Qs.stringify(data)}`),
};

const live = {
  get: (ross, all, select, gid_ross, offset, length, timeline, cashboxMode) => {

    let games = '';
    let gamesRoss = '';
    let video = null;

    if (select.games && select.games.length > 0) {
      games = select.games.join('-');
    }

    if (gid_ross.length > 0) {
      gamesRoss = _.intersectionWith(select.games, gid_ross, (x, y) => x == y).join('-');
    } else {
      gamesRoss = gid_ross.join('-');
    }

    if (all) {
      gamesRoss = gid_ross.join('-');
    }

    if (select.video) {
      video = 1;
    }

    const data = {
      ross,
      all,
      // lang_id,
      // sort_mode,
      // sport: sport || null,
      // league: league || null,
      onlyview: 0,
      video: video || null,
      games: games || null,
      games_ross: gamesRoss || null,
      print_mode: 'react',
      timezone: 3,
      cashbox_mode: typeof cashboxMode !== 'undefined' ? cashboxMode : 2,
    };

    // return requests.get(`/ajax/live/react/${getTime()}?${Qs.stringify(data, { skipNulls: true })}`)
// requests.get(`/ajax/live/react/${getTime()}?${Qs.stringify(data, { skipNulls: true })}`).then(console.log)
    return new Promise((resolve) => {
      resolve(mocData)
    })

  },
  getRoss: (games, showFromMain = 0) => {

    let gid = '';

    if (games.length > 0) {
      gid = games.join('-');
      return requests.get(`/ajax/live/react_ross/${getTime()}?onlyview=0&gid=${gid}&show_from_main=${showFromMain}`);
    }

    return false;

  },
  getData: () => {
    return requests.get(`/ajax/live/get_data`)
  },
  setData: (data) => {
    return requests.post(`/ajax/live/set_data`, { live_data: data })
  },
  getSchedule: () => {
    return requests.get(`/ajax/live/get_schedule`)
  },
  video: (gid, type) => requests.get(`/ajax/video/get?gid=${gid}&type=${type}`, { cancelable: true }),
};

/** @deprecated */
const basket = {
  get: (data, mode) =>
    requests.post(`/ajax/${mode}/load_bet`, data),
  set: (bet_data) =>
    requests.post(`/ajax/dobet`, bet_data),
  checkVip: (data) =>
    requests.post(`/ajax/dobet/vipbet`, { cards: data }),
  setOneClickAmount: (amount) =>
    requests.post(`/ajax/oneclick/apply`, { amount: amount }),
  getMax: (data) =>
    requests.post(`/ajax/line/get_max`, data)
};

const kafka = {
  kafkaLog: (log_data) => 
    requests.post('/api/metrics/v1/log', log_data),
}

class BasketAPI {
  constructor({ is_mobile } = { is_mobile: false }) {
    this.mobile_data = { info: is_mobile ? 1 : 0 };
  }

  getBet(bets, mode) {
    if (typeof bets === 'string' || typeof bets === 'number') {
      return requests.post(`/ajax/${mode}/load_bet`, { bids: [bets], ...this.mobile_data });
    }
    return requests.post(`/ajax/${mode}/load_bet`, { bets, ...this.mobile_data });
  }

  getBets(betIDs) {
    const data = Object.entries(betIDs)
      .map(([mode, bids]) => [mode, { bids, ...this.mobile_data }]);
    return requests.post('/ajax/line/bet/load_bets', Object.fromEntries(data));
  }
}

const line = {
  get: (ross, all, select, gid_ross, offset, length, timeline, cashboxMode) => {

    let games = '';
    let league = '';
    let sport = '';
    let gamesRoss = '';
    let popular_group = '';

    if (select.games && select.games.length > 0) {
      games = select.games.join('-');
    }

    if (!ross && gid_ross.length > 0) {
      gamesRoss = _.intersection(select.games, gid_ross).join('-');
    }

    if (select.league && select.league.length > 0) {
      league = select.league.join('-');
    }

    if (select.sport && select.sport.length > 0) {
      sport = select.sport.join('-');
    }

    if (select.popular_group && select.popular_group.length > 0) {
      popular_group = select.popular_group.join('-');
    }

    if (!games && !league && !sport) all = 1;

    if (select.type == 1) {
      games = '';
    }

    return requests.get(`/ajax/line/react?all=${all}&onlyview=0&timeline=${timeline}&sport=${sport}&league=${league}&games=${games}&ross=${ross}&popular_group=${popular_group ? popular_group : ''}${gamesRoss ? '&games_ross=' + gamesRoss : ''}${offset >= 0 ? '&offset=' + offset : ''}${length ? '&length=' + length : ''}&print_mode=react&timezone=3${typeof cashboxMode !== 'undefined' ? `&cashbox_mode=${cashboxMode}` : ''}`)
  },
  getRoss: (games, showFromMain = 0) => {

    let gid = '';

    if (games.length > 0) {
      gid = games.join('-');
      return requests.get(`/ajax/line/react_ross/?onlyview=0&gid=${gid}&show_from_main=${showFromMain}`);
    }

    return Promise.resolve({});

  },
  getData: () => {
    return requests.get(`/ajax/line/get_data`)
  },
  setData: (data) => {
    return requests.post(`/ajax/line/set_data`, { line_data: data })
  }
};

const toto = {
  getData: () =>
    requests.get(`/ajax/toto/get_data`),
  doBet: (data) =>
    requests.post(`/ajax/toto/dobet`, data),
  getBet: (id) =>
    requests.post(`/ajax/toto/get_bet`, { id: id }),
  getResult: (id) =>
    requests.get(`/ajax/toto/get_result?id=${id}`),
  getCards: (data) =>
    requests.post(`/ajax/toto/cards`, data),
  getPrevious: () =>
    requests.get(`/ajax/toto/get_previous`),
  getCardsAll: (data) =>
    requests.post(`/ajax/toto/get_cards_all`, data),
  getCardsPage: (data) =>
    requests.post(`/ajax/toto/cards_all`, data),
};

export default {
  BasketAPI,
  slides,
  lineMenu,
  live,
  liveMenu,
  line,
  auth,
  finance,
  terminal,
  data,
  user,
  basket,
  lineResults,
  liveResults,
  checker,
  search,
  toto,
  html,
  kafka
};



// WEBPACK FOOTER //
// ./src/api.js